// Pro Service spezifische FAQs für die Service-Übersichtsseiten
// (zusätzlich zum globalen FAQ unter /faq)
export const serviceFaqs: Record<string, { q: string; a: string }[]> = {
  entruempelung: [
    {
      q: "Was kostet eine Entrümpelung in Wien oder Niederösterreich?",
      a: "Richtwerte: Kleinwohnung bis 40 m² ab 590 €, 2-Zimmer ab 890 €, 3-Zimmer ab 1.290 €, Einfamilienhaus ab 2.490 €. Der Endpreis hängt von Volumen, Sperrgut-Anteil, Zugang (Stockwerk, Lift) und Zustand des Inventars ab. Verbindliches Angebot nach kostenloser Besichtigung.",
    },
    {
      q: "Was passiert mit gut erhaltenen Möbeln?",
      a: "Bei gut erhaltenem Inventar gestalten wir das Angebot entsprechend fair. Alle Stücke transportieren wir ab; die weitere Behandlung erfolgt über befugte Partnerbetriebe.",
    },
    {
      q: "Wie schnell kann eine Entrümpelung erfolgen?",
      a: "Besichtigung in der Regel binnen 48 Stunden, der eigentliche Räumungstermin meist innerhalb von 5–10 Tagen. In dringenden Fällen (kurzfristige Wohnungsübergabe) auch innerhalb von 24–72 Stunden möglich.",
    },
    {
      q: "Was gehört nicht in eine normale Entrümpelung?",
      a: "Asbest, Mineralwolle, große Mengen Bauschutt und heikle Stoffe wie Heizöl-Reste übernehmen wir nicht selbst – wir koordinieren dafür befugte Spezialbetriebe und nennen Ihnen den Aufpreis transparent im Angebot.",
    },
    {
      q: "Bekomme ich eine Bestätigung über den Abtransport?",
      a: "Ja. Auf Wunsch erhalten Sie eine Übernahmebestätigung über das abtransportierte Räumgut – wichtig für Hausverwaltungen, Versicherungen oder bei Liegenschaftsverkäufen.",
    },
    {
      q: "Macht ihr auch besenreine Übergabe?",
      a: "Standardmäßig ja. Auf Wunsch übernehmen wir auch Endreinigung (ab 290 €) oder Malerarbeiten und übergeben das Objekt schlüsselfertig an Hausverwaltung oder neue Mieter.",
    },
  ],
  "messi-wohnung": [
    {
      q: "Wie diskret läuft eine Messie-Räumung ab?",
      a: "Auf Wunsch absolut anonym: unbeschrifteter Transporter, neutrale Arbeitskleidung, Schleuse im Stiegenhaus, keine Kommunikation mit Nachbarn über die Art des Auftrags. Wir wissen, wie sensibel diese Situation für Betroffene und Angehörige ist.",
    },
    {
      q: "Was kostet eine Messie-Räumung?",
      a: "Richtwerte: bis 50 m² ab 1.490 €, 50–80 m² ab 2.490 €, 80–120 m² ab 3.490 €. Hinzu kommen ggf. Schädlingsbekämpfung (ab 290 €) und Grundreinigung/Geruchsneutralisation (ab 490 €). Verbindliches Angebot nach vertraulicher Erstbegehung.",
    },
    {
      q: "Wie geht ihr mit Schädlingsbefall um?",
      a: "Bei sichtbarem Befall koordinieren wir vorab einen zertifizierten Kammerjäger – wir räumen erst nach erfolgter Bekämpfung. So vermeiden wir Verschleppung in andere Wohnungen und schützen unser Team mit Vollschutz-PSA.",
    },
    {
      q: "Werden persönliche Dokumente gesichert?",
      a: "Ja, das ist Teil unserer Standardabwicklung. Wir sichten den Hausrat systematisch, sichern Pässe, Verträge, Bankunterlagen, Fotos, Briefe und Erinnerungsstücke in beschrifteten Boxen und übergeben sie Ihnen oder dem Verlassenschaftskurator.",
    },
    {
      q: "Reinigt ihr danach auch die Wohnung?",
      a: "Ja, wir bieten Grundreinigung, Geruchsneutralisation und auf Wunsch Desinfektion nach Räumung – sodass die Wohnung übergabefertig an Hausverwaltung oder neuen Mieter geht.",
    },
    {
      q: "Wer zahlt – Betroffene, Angehörige oder Hausverwaltung?",
      a: "Das hängt vom Einzelfall ab. Wir stellen die Rechnung an den, der den Auftrag erteilt – oft die Hausverwaltung (bei Räumungsklagen), Angehörige (bei Verlassenschaft) oder Sozialdienste. Auf Wunsch direkte Abrechnung mit Versicherung möglich.",
    },
  ],
  umzug: [
    {
      q: "Was kostet ein Privatumzug in Wien?",
      a: "Lokale Umzüge in Wien: 1-Zimmer ab 490 €, 2-Zimmer ab 790 €, 3-Zimmer ab 1.190 €, 4-Zimmer oder Einfamilienhaus ab 1.690 €. Im Angebot enthalten: Verpackungsmaterial, Decken, Demontage und Wiederaufbau. Möbellift, Halteverbot und Klaviertransport berechnen wir transparent extra.",
    },
    {
      q: "Wie lange dauert ein Umzug?",
      a: "Faustregel: 2-Zimmer-Wohnung 4–6 Stunden, 3-Zimmer 6–8 Stunden, Einfamilienhaus 1–2 Tage. Mit Möbellift verkürzt sich die Zeit oft deutlich. Die genaue Dauer schätzen wir bei der Besichtigung.",
    },
    {
      q: "Übernehmt ihr Möbeldemontage und -montage?",
      a: "Ja, das ist Standard im Angebot enthalten. Wir demontieren Betten, Schränke und Regale, transportieren sie sicher und bauen sie am neuen Standort wieder auf – inklusive korrekt vorgebohrter Wand-Halterungen.",
    },
    {
      q: "Beantragt ihr die Halteverbotszone?",
      a: "Ja, wir übernehmen die Beantragung bei der MA 46 (Wien) bzw. den jeweiligen Gemeindeämtern. Die Bearbeitungszeit beträgt in Wien rund 14 Tage – planen Sie das ein. Kosten ab 90 € (zuzüglich Gemeindegebühr).",
    },
    {
      q: "Übersiedelt ihr auch Klaviere oder Tresore?",
      a: "Ja, wir haben Klaviertrolley, Hebebühne und das nötige Personal. Pianino-Transport ab 190 €, Flügel und Tresore nach Aufmaß. Wichtig: Diese Gegenstände bitte bei der Besichtigung erwähnen – wir planen Personal und Equipment entsprechend.",
    },
    {
      q: "Sind die Möbel beim Umzug versichert?",
      a: "Ja, standardmäßig bis 25.000 € pro Auftrag. Für hochwertige Einzelstücke (Klavier, Kunst, Antiquitäten) erweitern wir die Deckung auf Wunsch.",
    },
  ],
  transport: [
    {
      q: "Welche Kleintransporte übernehmt ihr?",
      a: "Möbeltransporte, IKEA-Abholungen, Online-Käufe, Einzelstücke (Sofa, Schrank, Waschmaschine), Sperrgut, Bauteile, Werkzeug und Maschinen. Auch sensible Güter wie Bilder, Spiegel oder Pflanzen transportieren wir sicher mit Decken und Spanngurten.",
    },
    {
      q: "Was kostet ein Kleintransport?",
      a: "Ab 89 €/h für 1 Mann mit Transporter, ab 129 €/h für 2 Mann. Einzelstücke (IKEA-Abholung, Sofa) ab 149 € pauschal im Wiener Raum. Längere Strecken nach km + Stundensatz. Klavier oder Tresor auf Anfrage.",
    },
    {
      q: "Sind kurzfristige Termine (Same-Day) möglich?",
      a: "Ja, in der Regel ja – rufen Sie uns einfach an. Same-Day-Termine berechnen wir mit einem moderaten Eilzuschlag von 20 %.",
    },
    {
      q: "Bekomme ich Tragehilfe in die Wohnung?",
      a: "Ja, das ist Teil unseres Service. Wir tragen Möbel auch in höhere Stockwerke ohne Lift, schützen Wände und Geländer mit Decken und stellen die Gegenstände an Ihrem Wunschort ab.",
    },
    {
      q: "Welche Fahrzeuge habt ihr?",
      a: "Pick-Up mit großem Anhänger, Kleintransporter (bis 3,5 t) und Klein-LKW mit Hebebühne. Für größere Aufträge mieten wir zusätzlich 7,5-t-LKW dazu.",
    },
  ],
  wohnungsaufloesung: [
    {
      q: "Was kostet eine Wohnungsauflösung?",
      a: "Richtwerte: 1-Zimmer ab 690 €, 2-Zimmer ab 990 €, 3-Zimmer ab 1.490 €, Einfamilienhaus ab 2.890 €. Endreinigung ab 290 €. Bei gut erhaltenem Inventar gestalten wir den Preis entsprechend fair. Verbindliches Angebot nach Besichtigung.",
    },
    {
      q: "Wie läuft eine Wohnungsauflösung im Trauerfall ab?",
      a: "Einfühlsames Erstgespräch (telefonisch oder vor Ort), gemeinsame Sichtung des Inventars mit den Angehörigen, Sicherung von Dokumenten und Erinnerungsstücken, faire Preisgestaltung, besenreine Übergabe an Hausverwaltung oder Eigentümer. Auf Wunsch komplett in Ihrer Abwesenheit – wir koordinieren mit Verlassenschaftskurator und Notar.",
    },
    {
      q: "Muss ich beim Termin anwesend sein?",
      a: "Nein. Wir können auf Wunsch den Schlüssel von der Hausverwaltung übernehmen, dokumentieren den Auftrag fotografisch (vorher/nachher) und übergeben besenrein zurück. Sie erhalten regelmäßige Status-Updates per Mail und WhatsApp.",
    },
    {
      q: "Wird gut erhaltenes Inventar im Preis berücksichtigt?",
      a: "Ja. Antiquitäten, Schmuck, Münzsammlungen, Kunstwerke und hochwertige Möbel bewerten wir bei der Besichtigung und ziehen den Wert vom Auftragspreis ab. Bei Auflösungen in gut erhaltenen Haushalten reduziert das die Kosten häufig um 10–30 %.",
    },
    {
      q: "Übergebt ihr besenrein und schlüsselfertig?",
      a: "Standardmäßig ja, besenreine Übergabe ist im Angebot enthalten. Auf Wunsch übernehmen wir auch Endreinigung, kleinere Malerarbeiten oder Bodensanierung und übergeben das Objekt komplett schlüsselfertig.",
    },
    {
      q: "Was passiert mit persönlichen Dokumenten und Fotos?",
      a: "Wir sichern alle persönlichen Dokumente, Briefe, Fotoalben und Erinnerungsstücke in beschrifteten Boxen und übergeben sie Ihnen oder schicken sie auf Wunsch zu. Nichts wird ohne Ihre Freigabe abtransportiert.",
    },
  ],
  firmenumzug: [
    {
      q: "Was kostet ein Firmenumzug?",
      a: "Richtwerte: Kleinbetrieb bis 5 Mitarbeiter ab 1.890 €, Mittelbetrieb 5–20 Mitarbeiter ab 3.490 €, Großbetriebe und Produktionsverlagerungen nach Projektpreis. Wochenend-/Nachtzuschläge 20 %. Detaillierter Angebot nach Begehung und Projektplanung.",
    },
    {
      q: "Wie minimiert ihr die Ausfallzeit?",
      a: "Wir arbeiten Freitag–Sonntag oder über Nacht, sodass Sie Montagmorgen wieder voll einsatzbereit sind. Vorab erstellen wir einen detaillierten Projektplan mit Verantwortlichkeiten, Meilensteinen und Notfall-Strategie.",
    },
    {
      q: "Demontiert und montiert ihr auch Maschinen und Regalsysteme?",
      a: "Ja. Wir demontieren Schwerlastregale, Werkstatt-Hebebühnen, Maschinen (bis 5 t) und Produktionseinrichtungen, transportieren sie und bauen sie am neuen Standort wieder auf. Bei sehr schwerem Equipment koordinieren wir Spezialdienstleister.",
    },
    {
      q: "Wie wird mit sensiblen Daten und Akten umgegangen?",
      a: "DSGVO-konform: Akten transportieren wir in versiegelten, nummerierten Boxen, Server und IT-Equipment fachgerecht verpackt mit Fachpersonal. Auf Wunsch unterschreiben wir Vertraulichkeitsvereinbarungen.",
    },
    {
      q: "Übernehmt ihr auch IT-Verkabelung und Aufstellung?",
      a: "Wir übernehmen Demontage, Transport und Wiederaufstellung der Hardware. Die Re-Verkabelung und Software-Inbetriebnahme koordinieren wir auf Wunsch mit Ihrem IT-Partner oder einem unserer Partnerbetriebe.",
    },
    {
      q: "Transportiert ihr auch Altequipment und alte Akten ab?",
      a: "Ja. Altmöbel, Altgeräte und veraltete Aktenbestände transportieren wir ab. Akten mit personenbezogenen Daten vernichten wir DSGVO-konform mit zertifizierten Vernichtungspartnern und stellen das Vernichtungszertifikat aus.",
    },
  ],
  bueroumzug: [
    {
      q: "Was kostet ein Büroumzug?",
      a: "Richtwerte: pro Arbeitsplatz ab 149 €, Besprechungsraum komplett ab 490 €, Server-/IT-Raum ab 690 €. Aktentransport DSGVO-konform ab 49 €/Laufmeter. Angebot nach Begehung und Bestandsaufnahme.",
    },
    {
      q: "Wie läuft die Etikettierung der Arbeitsplätze ab?",
      a: "Jeder Karton, jedes Möbelstück und jedes IT-Gerät erhält einen farbkodierten Zielraum-Code. Am neuen Standort steht alles exakt am richtigen Platz – Ihre Mitarbeiter finden ihren Arbeitsplatz Montagmorgen 1:1 wieder vor.",
    },
    {
      q: "Wie sicher ist der Transport von Akten?",
      a: "DSGVO-konform: Akten kommen in versiegelte, nummerierte Boxen mit Übergabeprotokoll. Vom Aufnahmeort zum Zielort lückenlose Dokumentation – inkl. Vier-Augen-Prinzip bei sensiblen Personalakten.",
    },
    {
      q: "Übersiedelt ihr auch Server und IT-Equipment?",
      a: "Ja. Bildschirme, PCs, Server und Netzwerk-Hardware verpacken wir fachgerecht in Anti-Statik-Boxen, transportieren sie erschütterungsarm und bauen sie am Zielort wieder auf. Auf Wunsch mit IT-Partner für Re-Verkabelung.",
    },
    {
      q: "Arbeitet ihr am Wochenende?",
      a: "Standard für Büroumzüge: Umzug Freitag–Sonntag, Montag läuft der Betrieb. Wochenendzuschlag 20 %. Für viele Firmen rechnet sich das durch die vermiedene Ausfallzeit mehrfach.",
    },
    {
      q: "Transportiert ihr Altmöbel und Altequipment ab?",
      a: "Ja, alte Bürostühle, Schreibtische, Container und ausgemusterte IT-Geräte transportieren wir ab. Funktionierende Möbel rechnen wir teilweise an, alte IT vernichten wir DSGVO-konform und stellen Zertifikat aus.",
    },
  ],
};

// "Warum Schober" – pro Service angepasste USPs
export const serviceWhyUs: Record<string, string[]> = {
  entruempelung: [
    "Angebot nach kostenloser Besichtigung – keine Nachverrechnung",
    "Faire Preisgestaltung bei gut erhaltenem Inventar",
    "Eigenes geschultes Team, eigener Fuhrpark, keine Subunternehmer",
    "Versichert bis 25.000 € pro Auftrag",
    "Räumung und Abtransport aus einer Hand – Übernahmebestätigung auf Wunsch",
    "Besenreine Übergabe inkl. Foto-Dokumentation für Hausverwaltung",
  ],
  "messi-wohnung": [
    "Absolute Diskretion – unbeschrifteter Transporter auf Wunsch",
    "Vollschutzausrüstung (PSA) nach ÖNORM, geschultes Personal",
    "Koordination Kammerjäger & Desinfektion aus einer Hand",
    "Sicherung persönlicher Dokumente, Schmuck, Erinnerungen",
    "Empathisches Auftreten – Erfahrung aus Polizei-Hintergrund",
    "Übergabefertige Wohnung inkl. Geruchsneutralisation",
  ],
  umzug: [
    "Komplettservice A bis Z – Verpackung, Transport, Aufbau",
    "Angebot ohne versteckte Kosten",
    "Versicherter Transport bis 25.000 €",
    "Möbellift, Halteverbot, Klaviertransport organisieren wir mit",
    "Möbeldemontage und Wiederaufbau durch Profis",
    "Eigene Mannschaft – kein Wechsel-Personal aus Subunternehmen",
  ],
  transport: [
    "Same-Day-Termine in der Regel möglich",
    "Versichert bis 25.000 € pro Transport",
    "Hebebühne, Sackkarre, Klaviertrolley – das richtige Equipment",
    "Faire, transparente Stunden- oder Pauschalpreise",
    "Pünktlichkeit ist Standard – wir kommen wann zugesagt",
    "Tragehilfe in die Wohnung inklusive",
  ],
  wohnungsaufloesung: [
    "Empathische Abwicklung im Trauerfall",
    "Faire Preisgestaltung bei gut erhaltenem Inventar",
    "Sicherung persönlicher Dokumente und Erinnerungsstücke",
    "Schlüsselübergabe an Hausverwaltung möglich – ohne Ihre Anwesenheit",
    "Endreinigung und Malerarbeiten auf Wunsch",
    "Bundesweite und EU-weite Abwicklung",
  ],
  firmenumzug: [
    "Wochenend- und Nachtumzüge – minimale Ausfallzeit",
    "Detaillierte Projektplanung mit Meilensteinen",
    "Maschinen- und Regalsystem-Demontage inklusive",
    "DSGVO-konformer Akten- und IT-Transport",
    "Spezialverpackung für sensible Hardware",
    "Abtransport von Altequipment & Altakten inklusive Zertifikat",
  ],
  bueroumzug: [
    "Etiketten-System – jeder Arbeitsplatz exakt am richtigen Ort",
    "DSGVO-konformer Aktentransport in versiegelten Boxen",
    "Fachgerechte IT-Verpackung & Re-Aufstellung",
    "Möbeldemontage und Wiederaufbau standard",
    "Wochenend-Umzug, Montag läuft der Betrieb",
    "Abtransport von Altmöbeln mit DSGVO-Zertifikat für Akten",
  ],
};
